// Code-based TanStack Router. The tree lives in routes/sections.tsx.

import { createRouter } from '@tanstack/react-router';
import { routeTree } from './routes/sections';
import { queryClient } from './lib/queryClient';
import { captureException } from './lib/observability';
import { NotFoundState } from './components/states/NotFoundState';

export const router = createRouter({
  routeTree,
  context: { queryClient },
  defaultPreload: 'intent',
  defaultNotFoundComponent: NotFoundState,
  // Route-level catch boundary (loader / render errors that reach TanStack's
  // own CatchBoundary rather than LaneShell's) → Sentry via the façade.
  defaultOnCatch: (error, info) =>
    captureException(error, {
      componentStack: info.componentStack,
      tags: { boundary: 'router' },
    }),
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
